// @ts-nocheck
/* eslint-disable */

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.List = void 0;

var _react = _interopRequireDefault(require('react'));

var _propTypes = _interopRequireDefault(require('prop-types'));

var _List = require('./List.styled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var List = function List(props) {
  var children = props.children;
  return _react.default.createElement(_List.StyledList, props, children);
};
/**
 * Definition of default values for component props
 */

exports.List = List;
List.defaultProps = {
  children: undefined,
  width: undefined,
  disabled: false,
  className: undefined,
  id: undefined
};
/**
 * Definition of types for component props
 */

List.propTypes = {
  /** Collection of items in the list. Must be a collection of ListItems */
  children: _propTypes.default.node,

  /** The CSS width property for the list */
  width: _propTypes.default.string,

  /** Wheather the list is disabled or not. If 'true', the items cannot be clicked */
  disabled: _propTypes.default.bool,

  /** Component ClassName */
  className: _propTypes.default.string,

  /** Component id */
  id: _propTypes.default.string
};
